<template>
  <div class="home">
    <pan :client="client"></pan>
    <div class="content-center">



      <p-title class="animated bounceIn" :title="title"></p-title>
      <list :state="state" :client="client" :list-url="listUrl"></list>
      <template v-if="!newPaoIsHasData">
        <p-title class="animated bounceIn" :title="title2"></p-title>
        <swiper1 @dataEmptyFun="dataEmptyFun"></swiper1>
      </template>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pan from '@/components/pan'
import swiper1 from '@/components/swiper1'
import pTitle from '@/components/title'
import list from '@/components/list'
import pageFooter from '@/components/footer'
export default {
  name: 'homeIndex',
  props: ['client'],
  data () {
    return {
      title: {
        title: '<span>推荐</span>全景'
      },
      title2: {
        title: '<span>最新</span>全景'
      },
      activeIndex: 0,
      state: 0,
      listUrl: 'PanoWebService.asmx/GetRecommendByCity',



      studentComment:{},
      studentCommentScore:[],
      studentCommentVal:[],
      newPaoIsHasData:false,
    }
  },
  components: {
    pan: pan,
    swiper1: swiper1,
    pTitle: pTitle,
    list: list,
    pageFooter: pageFooter
  },
  mounted () {
  },
  created () {
    document.title = '魅力'+(this.$realmNameId==50?'重庆':'四川');
    this.$emit('topState', 0)
//    this.publicJs.setUrlCookie('Url',window.location.href)
  },
  computed:{
  },
  methods: {
    dataEmptyFun(val){
      this.newPaoIsHasData=val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .love-comment {
    display: flex;
    flex-wrap: wrap;

  }
  .love-comment p{
    padding: 10px;
    border:1px solid gray;
  }
  .love-comment .ac{
    color: red;
  }
  >>>.tip{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue